import type { DeepPartial } from '@luna/utils-ts';

import { initRetailFeatureConfig } from './initConfig';
import type { RetailFeatureConfig } from './RetailFeatureConfig';
import { baseFeatureConfig } from './base';
import { featureConfig as featureConfigAT } from './AT';
import { featureConfig as featureConfigCZ } from './CZ';
import { featureConfig as featureConfigSK } from './SK';
import { featureConfig as featureConfigRO } from './RO';
import { featureConfig as featureConfigHR } from './HR';
import { featureConfig as featureConfigHU } from './HU';
import { featureConfig as featureConfigRS } from './RS';

export const countryFeatureConfigMap = {
    base: baseFeatureConfig,
    AT: featureConfigAT,
    CZ: featureConfigCZ,
    'CZ-UAT': featureConfigCZ,
    SK: featureConfigSK,
    RO: featureConfigRO,
    HR: featureConfigHR,
    HU: featureConfigHU,
    RS: featureConfigRS,
};

export const loadRetailFeatureConfig = () => initRetailFeatureConfig(countryFeatureConfigMap);

export type PartialRetailFeatureConfig = DeepPartial<RetailFeatureConfig>;
